<template>
    <div>
        <Head title="Озера"/>
        <h1 class="mb-8 text-3xl font-bold">Озера</h1>
        <div class="flex items-center justify-between mb-6">
<!--            <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">-->
<!--                <label class="block text-gray-700">Trashed:</label>-->
<!--                <select v-model="form.trashed" class="form-select mt-1 w-full">-->
<!--                    <option :value="null"/>-->
<!--                    <option value="with">With Trashed</option>-->
<!--                    <option value="only">Only Trashed</option>-->
<!--                </select>-->
<!--            </search-filter>-->
            <Link
                class="btn-indigo"
                :href="$route('lakes.create')"
            >
                <span>Створити</span>
                <span class="hidden md:inline"> озеро</span>
            </Link>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
            <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                    <th class="pb-4 pt-6 px-6">Назва</th>
                </tr>
                <tr v-for="lake in lakes.data" :key="lake.id"
                    class="hover:bg-gray-100 focus-within:bg-gray-100">
                    <td class="border-t">
                        <Link
                            class="flex items-center px-6 py-4 focus:text-indigo-500"
                            :href="$route('lakes.edit', lake.id)"
                        >
                            {{ lake.name }}
                        </Link>
                    </td>
                </tr>
                <tr v-if="lakes.data.length === 0">
                    <td class="px-6 py-4 border-t" colspan="4">Немає жодного запису</td>
                </tr>
            </table>
        </div>
        <pagination class="mt-6" :links="lakes.links"/>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
    components: {
        Head,
        Icon,
        Link,
        Pagination,
        SearchFilter,
    },
    layout: Layout,
    props: {
        filters: Object,
        lakes: Object,
    },
    data() {
        return {
            form: {
                search: this.filters.search,
                trashed: this.filters.trashed,
            },
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get(this.$route('lakes.index'), pickBy(this.form), {preserveState: true})
            }, 150),
        },
    },
    methods: {
        reset() {
            this.form = mapValues(this.form, () => null)
        },
    },
}
</script>
